import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchSiteImages, resolveImg } from '../api';

// Default images (fallback, mirrors backend DEFAULT_SITE_IMAGES)
export const DEFAULT_IMAGES = {
  home_hero: '/images/hero-gr.jpg',
  whatisgr_hero: 'https://images.pexels.com/photos/7186293/pexels-photo-7186293.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  whatisgr_gallery_1: 'https://images.pexels.com/photos/7186303/pexels-photo-7186303.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  whatisgr_gallery_2: 'https://images.pexels.com/photos/7186620/pexels-photo-7186620.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  ourclub_hero: 'https://images.pexels.com/photos/7186300/pexels-photo-7186300.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  inscriptions_hero: 'https://images.pexels.com/photos/7186302/pexels-photo-7186302.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  results_hero: 'https://images.pexels.com/photos/7186293/pexels-photo-7186293.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
  boutique_hero: 'https://images.pexels.com/photos/7186303/pexels-photo-7186303.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940&h=650&fit=crop',
};

const SiteImagesContext = createContext(DEFAULT_IMAGES);

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState(DEFAULT_IMAGES);

  useEffect(() => {
    fetchSiteImages()
      .then((data) => {
        if (data && data.images) {
          const merged = { ...DEFAULT_IMAGES, ...data.images };
          const resolved = Object.fromEntries(
            Object.entries(merged).map(([k, v]) => [k, resolveImg(v)])
          );
          setImages(resolved);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <SiteImagesContext.Provider value={images}>
      {children}
    </SiteImagesContext.Provider>
  );
};

export const useSiteImages = () => useContext(SiteImagesContext);
